import styles from './divider.module.scss';

export const Divider = ({ ...props }: React.ComponentPropsWithoutRef<'div'>) => {
    return <div {...props} className={styles.divider} />;
};
